import React, { useState } from 'react';
import * as S from './TopRoutes.styles';
import Button from '../../../../core-components/Button/ButtonUI';
import Icon from '../../../../core-components/IconsSelector';
import ToolTipUI from '../../../../core-components/ToolTip/ToolTipUI';


export default function({ route, isCarType = false, onAction, toolTipData }) {
    const [visited, setVisited] = useState(false);
    if (!route?.title && !isCarType) {
        return null;
    }
    return (
        <S.Body>
            <S.RouteColumn>
                {isCarType && <S.RouteImageWrapper src={route?.img_url} alt="Cab Image" />}
                <S.RouteColumnWrapper>
                    {isCarType ? (
                        <S.BodyTitle>
                            {route?.car_types}
                        </S.BodyTitle>
                    ) : (
                        <S.BodyTitle>
                            <a href={route?.link}>
                                {route?.title}
                            </a>
                        </S.BodyTitle>
                    )}
                    <S.BodySubTitle>{isCarType ? route?.car_types_subtitle : route?.subtitle}</S.BodySubTitle>
                </S.RouteColumnWrapper>
            </S.RouteColumn>
            <S.FareColumn>
                <S.IconWrapper>
                    <Icon name="TickIcon" />
                </S.IconWrapper>
                <S.FareWrapper>
                    {route?.includedDistance && <S.BodyTitle>{route?.includedDistance}</S.BodyTitle>}
                    {route?.extraFare && <S.BodySubTitle>{route?.extraFare}</S.BodySubTitle>}
                </S.FareWrapper>
            </S.FareColumn>
            <S.PriceColumn>
                {route?.startingPrice && (
                    <React.Fragment>
                        <S.PriceWrapper>{`₹${route?.startingPrice}`}</S.PriceWrapper>
                        <S.BodySubTitle>onwards</S.BodySubTitle>
                    </React.Fragment>
                )}
            </S.PriceColumn>
            <S.CTAColumn>
                <Button name={isCarType ? 'BOOK NOW' : 'VIEW CABS'} onClick={() => onAction(route)} />
                {route?.isLPG && toolTipData?.lTitle && (
                    <S.LPGWrapper>
                        <S.LPGTitle
                            dangerouslySetInnerHTML={{ __html: toolTipData?.lTitle?.split("&lt;").join("<").split("&gt;").join(">") }} 
                        />
                        &nbsp;
                        <S.LPGSubTitle
                            onMouseOver={() => setVisited(true)}
                            onMouseOut={() => setVisited(false)}
                        >
                            {toolTipData?.lSubTitle}
                            {toolTipData?.toolTipData && visited && (
                                <S.ToolTipWrapper>
                                    <ToolTipUI title={""} data={toolTipData?.toolTipData} showIcon={false} beforeLeft={"3rem"} />
                                </S.ToolTipWrapper>
                            )}
                        </S.LPGSubTitle>
                    </S.LPGWrapper>
                )}
            </S.CTAColumn>
        </S.Body>
    )
}